import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles({
  root: {
    maxWidth: 345,
    margin: 10,
    color: "#002D55",
    borderColor: "#002D55",
    border: "1px solid",
    "&:hover": {
        backgroundColor: "#002d55",
        color: "#FFFFFF",
        borderColor: "#0062cc",
        boxShadow: "none"
      },
    "&:active": {
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.5)",
        backgroundColor: "#0062cc",
        borderColor: "#005cbf"
      },
    "&:focus": {
        boxShadow: "0 0 0 0.2rem rgba(0, 45, 85, 0.8)"
      }
  },
  media: {
    height: 140,
  },
  
});

export default function PictureChoice() {
  const classes = useStyles();

  return (
    <Grid container direction="row">
    <Card className={classes.root}>
      <CardActionArea>
        <CardMedia
          className={classes.media}
          image=""
          title=""
        />
        <CardContent>
          <Typography variant="h5" color="textSecondary" component="p">
            Picture choice 1
          </Typography>
        </CardContent>
      </CardActionArea>
   </Card>
   <Card className={classes.root}>
      <CardActionArea>
        <CardMedia
          className={classes.media}
          image=""
          title=""
        />
        <CardContent>
          <Typography variant="h5" color="textSecondary" component="p">
            Picture choice 1
          </Typography>
        </CardContent>
      </CardActionArea>
   </Card>
   </Grid>
  );
}


